import React from 'react';
import memoize from 'lodash.memoize';
import styles from './style.css';
import loadFlows from '../../core/load-flows';
import FlowEngine from '../../core/flow-engine';
import { getFlows } from '../../core/flow-register';

const memoizedLoadFlows = memoize(loadFlows);

const Flow = () => {
  memoizedLoadFlows();

  return (
    <div className="flow-engine" data-name="flowEngineWrapper">
      <FlowEngine flows={getFlows()} />
      <style jsx>{styles}</style>
    </div>
  );
};

export default Flow;
